import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import timezone from "dayjs/plugin/timezone.js";

dayjs.extend(utc);
dayjs.extend(timezone);

export const getDiffDateAndTime = (param) => {
  if (dayjs(param).isValid()) {
    return dayjs(param).format("MMMM DD, YYYY h:mm A");

    // const evtDate = dayjs(param);
    // const today = dayjs();

    // let hours = today.diff(evtDate, "hours");
    // const days = Math.floor(hours / 24);
    // hours = hours - days * 24;

    // if (days === 0) {
    //   return <>{hours} hours ago</>;
    //   // return ( <>{hours} hours ago</>);
    // } else {
    //   return dayjs(param).format("MMMM DD, YYYY h:mm A");
    // }
  }
};

export const getTransactionTime = (param) => {
  if (dayjs(param).isValid()) {
    return dayjs(param).format("hh:mm A");
  }
};

export const getTransactionDateAway = (param) => {
  if (dayjs(param).isValid()) {
    return dayjs(param).format("DD/MM/YYYY");

    // const evtDate = dayjs(param);
    // const today = dayjs();

    // let hours = today.diff(evtDate, 'hours');
    // const days = Math.floor(hours / 24);
    // hours = hours - (days * 24);

    // if (days === 0) {
    //     return (<>{hours} hours ago</>);
    //     // return ( <>{hours} hours ago</>);
    // } else {
    //     return dayjs(param).format('DD/MM/YYYY');
    // }
  }
};

export const convertTZ = (date, tzString) => {
  let timestamp = date;
  let tz = tzString;
  const dayjsLocal = dayjs.utc(timestamp);
  const dayjsAmerica = dayjsLocal.tz(tz);
  var timeZoneCountry = dayjsAmerica.format("YYYY-MM-DDTHH:mm:ss");
  return timeZoneCountry;
};

export const getTime = (date) => {
  date = date.trim();
  let datetransactions = convertTZ(date, "Asia/Colombo");
  let transactionDate = getTransactionTime(
    datetransactions.toString().split(",")[0]
  );
  return transactionDate;
};

export const getDate = (date) => {
  console.log('date', date)
  let datetransactions = convertTZ(date, "Asia/Colombo");
  let transactionDate = getTransactionDateAway(
    datetransactions.toString().split(",")[0]
  );
  return transactionDate;
};

export const getDateHistory = (date) => {
  let dateHistory = convertTZ(date, "Asia/Colombo");
  let paymentCreatedDate = getDiffDateAndTime(dateHistory.toString());
  return paymentCreatedDate;
};
